/* global axios */
import ApiClient from './ApiClient';

class ReferralsAPI extends ApiClient {
  constructor() {
    super('referrals', { accountScoped: true });
  }

  get(contactId) {
    return axios.get(`${this.baseUrl()}/contacts/${contactId}/referrals`);
  }

  create(contactId, data) {
    return axios.post(
      `${this.baseUrl()}/contacts/${contactId}/referrals`,
      data
    );
  }

  getStats(contactId) {
    return axios.get(`${this.baseUrl()}/contacts/${contactId}/referral_stats`);
  }

  findReferrerConversationByTelegram(telegramId) {
    return axios.get(`${this.baseUrl()}/conversations/search_by_telegram`, {
      params: { telegram_id: telegramId },
    });
  }
}

export default new ReferralsAPI();
